<template>
  <div class="flex flex-col gap-8">
    <AccordionRow
      v-for="item in items"
      :key="item.id"
      :label="item.label"
      :sublabel="item.sublabel"
      :icon="item.icon"
      :icon-color="item.iconColor"
    >
      <template v-if="$slots[`content-${item.id}`]" #accordion-content>
        <slot :name="`content-${item.id}`" />
      </template>
    </AccordionRow>
  </div>
</template>

<script lang="ts">
import AccordionRow from '@/components/accordion_row/AccordionRow.vue';

interface AccordionItem {
  id: string;
  label: string;
  sublabel?: string;
  icon?: object;
  iconColor?: string;
}

export default {
  name: 'AccordionList',
  components: { AccordionRow },
  props: {
    items: {
      type: Array as () => AccordionItem[],
      required: true,
    },
  },
};
</script>
